window.SwymWishlist = window.SwymWishlist || {};

SwymWishlist.badgeCache = new Map();

SwymWishlist.getLocaleRoot = function () {
  const shopifyRoot = window.Shopify?.routes?.root || '/';
  if (shopifyRoot && shopifyRoot !== '/') return shopifyRoot;

  const firstPathPart = window.location.pathname.split('/').filter(Boolean)[0];
  if (firstPathPart && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(firstPathPart)) {
    return '/' + firstPathPart + '/';
  }

  return '/';
};

SwymWishlist.getLocalizedPath = function (path) {
  const root = SwymWishlist.getLocaleRoot();
  return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
};

SwymWishlist.renderWishlist = function (products) {
  const container = document.getElementById('swym-wishlist-container');
  const emptyState = document.getElementById('swym-wishlist-empty');
  const template = document.getElementById('swym-wishlist-item-template');
  const shareBlock = document.querySelector('.swym-wishlist__share');
  const loadingEl = container.querySelector('.swym-wishlist__loading');

  if (loadingEl) loadingEl.style.display = 'none';
  container.innerHTML = '';
  SwymWishlist.state.products = products || [];
  SwymWishlist.updateCounter(SwymWishlist.state.products.length);

  if (shareBlock) {
    shareBlock.style.display = (SwymWishlist.state.products.length > 0 && !SwymWishlist.state.isSharedView) ? 'flex' : 'none';
  }

  if (!products || products.length === 0) {
    container.style.display = 'none';
    emptyState.style.display = 'flex';
    const recsContainer = document.getElementById('swym-wishlist-recommendations');
    if (recsContainer) recsContainer.style.display = 'none';
    return;
  }

  container.style.display = 'grid';
  emptyState.style.display = 'none';

  const badgeItems = [];

  products.forEach(function (product) {
    const clone = template.content.cloneNode(true);
    const item = clone.querySelector('.swym-wishlist__item');

    item.dataset.empi = product.empi;
    item.dataset.epi = product.epi;
    item.dataset.du = product.du;

    const link = clone.querySelector('[data-product-link]');
    link.href = product.du;

    const image = clone.querySelector('[data-product-image]');
    image.alt = product.dt || '';
    image.style.display = 'none';
    image.closest('.swym-wishlist__item-media').classList.add('swym-wishlist__item-media--placeholder');

    clone.querySelector('[data-product-title]').textContent = product.dt;

    const variantEl = clone.querySelector('[data-product-variant]');
    if (product.variants && product.vi) {
      variantEl.textContent = product.vi;
    } else {
      variantEl.style.display = 'none';
    }

    clone.querySelector('[data-product-price]').textContent = SwymWishlist.formatMoney(product.pr * 100);

    const removeBtn = clone.querySelector('[data-action="remove"]');
    if (SwymWishlist.state.isSharedView) {
      removeBtn.style.display = 'none';
    } else {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        SwymWishlist.removeFromWishlist(product);
      });
    }

    container.appendChild(clone);
    badgeItems.push({ url: product.du, element: item });
  });

  SwymWishlist.fetchAllBadges(badgeItems);
  SwymWishlist.refreshAllProductData(badgeItems);
  SwymWishlist.loadRecommendations(products);
};


SwymWishlist.refreshAllProductData = async function (items) {
  await Promise.all(items.map(function (item) {
    return SwymWishlist.refreshProductData(item);
  }));
};

SwymWishlist.refreshProductData = async function (item) {
  try {
    const url = new URL(item.url, window.location.origin);
    const handle = url.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;

    const epi = parseInt(item.element.dataset.epi);
    let fetchUrl = SwymWishlist.getLocalizedPath('/products/' + handle + '.js');
    let response = await fetch(fetchUrl);

    if (response.status === 404) {
      const pageRes = await fetch(SwymWishlist.getLocalizedPath('/products/' + handle));
      const resolvedHandle = pageRes.url.split('/products/')[1]?.split(/[?#]/)[0];
      if (resolvedHandle && resolvedHandle !== handle) {
        item.url = pageRes.url;
        const linkEl = item.element.querySelector('[data-product-link]');
        if (linkEl) linkEl.href = pageRes.url;
        fetchUrl = SwymWishlist.getLocalizedPath('/products/' + resolvedHandle + '.js');
        response = await fetch(fetchUrl);
      }
    }

    if (!response.ok) return;

    const data = await response.json();
    const variant = data.variants.find(function (v) { return v.id === epi; }) || data.variants[0];

    const titleEl = item.element.querySelector('[data-product-title]');
    if (titleEl && data.title) {
      titleEl.textContent = data.title;
      const image = item.element.querySelector('[data-product-image]');
      if (image) image.alt = data.title;
    }

    const variantEl = item.element.querySelector('[data-product-variant]');
    if (variantEl && variantEl.style.display !== 'none' && variant && variant.public_title) {
      variantEl.textContent = variant.public_title;
    }

    const priceEl = item.element.querySelector('[data-product-price]');
    if (priceEl) {
      const priceVaries = data.variants.length > 1 && data.price_varies;
      if (priceVaries) {
        const fromPrice = SwymWishlist.formatMoney(data.price_min);
        const template = SwymWishlist.priceFromTemplate || 'From %%PRICE%%';
        priceEl.textContent = template.replace('%%PRICE%%', fromPrice);
      } else if (variant) {
        priceEl.textContent = SwymWishlist.formatMoney(variant.price);
      }
    }

    const rawSrc = (variant && variant.featured_image && variant.featured_image.src)
      || data.featured_image
      || (data.images && data.images[0]);
    const liveImageSrc = rawSrc && (typeof rawSrc === 'string' ? rawSrc : rawSrc.src);
    if (liveImageSrc) {
      let imageUrl = liveImageSrc;
      if (!imageUrl.startsWith('http')) imageUrl = 'https:' + imageUrl;
      imageUrl = imageUrl.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_480x$1$3');
      const image = item.element.querySelector('[data-product-image]');
      const media = image && image.closest('.swym-wishlist__item-media');
      if (image) {
        image.onerror = null;
        image.src = imageUrl;
        image.style.display = '';
        if (media) media.classList.remove('swym-wishlist__item-media--placeholder');
      }
    }
  } catch (err) { }
};

SwymWishlist.fetchAllBadges = async function (items) {
  const BATCH_SIZE = 4;
  for (let i = 0; i < items.length; i += BATCH_SIZE) {
    const batch = items.slice(i, i + BATCH_SIZE);
    await Promise.all(batch.map(item => SwymWishlist.fetchProductBadges(item.url, item.element)));
  }
};

SwymWishlist.fetchProductBadges = async function (productUrl, itemElement) {
  try {
    const url = new URL(productUrl, window.location.origin);
    const handle = url.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;

    const cacheKey = `${SwymWishlist.getLocaleRoot()}:${handle}`;
    let badgesHtml = SwymWishlist.badgeCache.get(cacheKey);
    if (!badgesHtml) {
      let response = await fetch(SwymWishlist.getLocalizedPath(`/products/${handle}?sections=product-badges-ajax`));
      if (response.status === 404) {
        const pageRes = await fetch(SwymWishlist.getLocalizedPath('/products/' + handle));
        const resolvedHandle = pageRes.url.split('/products/')[1]?.split(/[?#]/)[0];
        if (resolvedHandle && resolvedHandle !== handle) {
          response = await fetch(SwymWishlist.getLocalizedPath(`/products/${resolvedHandle}?sections=product-badges-ajax`));
        }
      }
      if (!response.ok) return;
      const data = await response.json();
      badgesHtml = data['product-badges-ajax'];
      if (badgesHtml) SwymWishlist.badgeCache.set(cacheKey, badgesHtml);
    }

    const badgesContainer = itemElement.querySelector('[data-product-badges]');
    if (!badgesContainer || !badgesHtml) return;

    const temp = document.createElement('div');
    temp.innerHTML = badgesHtml.trim();
    const sectionWrapper = temp.querySelector('.shopify-section');
    badgesContainer.innerHTML = sectionWrapper ? sectionWrapper.innerHTML : badgesHtml.trim();
  } catch (err) { }
};

SwymWishlist.removeFromWishlist = function (product) {
  if (!window._swat) return;

  window._swat.removeFromWishList(
    {
      empi: product.empi,
      epi: product.epi,
      du: product.du
    },
    function () {
      window._swat.fetch(SwymWishlist.renderWishlist);
    }
  );
};
